<template>
<div id="card-details">
    <HeadDetailsGama  :titleHead="'Detalhe consulta de vendas'"></HeadDetailsGama>
    <div id="body-details" class="mt-4 ml-2">
            <p  class="ml-3 subtitle">Empreendimento</p>
            <div class="corpo-corretor d-flex">
                <div class="nome-empreendimento">
                    <p class="label-details">Empreendimento</p>
                    <input class="input-details" v-model="selectedComissao.empreendimento.nome" disabled >
                </div>
                <div class="nome-cidade">
                    <p class="label-details">Cidade</p>
                    <input class="input-details" v-model="selectedComissao.empreendimento.cidade.nome" disabled>
                </div>
                <div class="nome-rua">
                    <p class="label-details">Rua</p>
                    <input disabled class="input-details" v-model="selectedComissao.empreendimento.endereco">
                </div>
            </div>
            <div class="corpo-corretor margin d-flex">
                <div class="cep-numero">
                    <p class="label-details">Cep</p>
                    <input disabled v-model="selectedComissao.empreendimento.cep" class="input-details">
                </div>
                <div class="nome-rua">
                    <p class="label-details">Bairro</p>
                    <input disabled v-model="selectedComissao.empreendimento.bairro" class="input-details">
                </div>
                <div class="">
                    <p class="label-details">Número</p>
                    <input class="input-details" disabled v-model="selectedComissao.empreendimento.numero">
                </div>
                <div class="torre-apartamento">
                    <p class="label-details">Torre</p>
                    <input disabled  v-model="selectedComissao.proposta.empreendimentoUnidade.grupo" class="input-details">
                </div>
                <div class="">
                    <p class="label-details">Apartamento</p>
                    <input disabled v-model="selectedComissao.proposta.empreendimentoUnidade.unidade" class="input-details">
                </div>
            </div>
            <p  class="subtitle margin left">Corretor</p>
            <div class="corpo-corretor d-flex flex-wrap">
                <div class="nome-corretor">
                    <p class="label-details">Nome</p>
                    <input disabled  v-model="selectedComissao.conta.nome" class="input-details">
                </div>
                <div class="nome-corretor">
                    <p class="label-details">E-mail</p>
                    <input disabled v-model="selectedComissao.proposta.conta.email" class="input-details">
                </div>
                <div class="cpf-corretor">
                    <p class="label-details">CPF</p>
                    <input disabled v-model="selectedComissao.corretor.cpf" class="input-details">
                </div>
            </div>
            <div class="corpo-corretor margin d-flex flex-wrap">
                <div class="basico-corretor">
                    <p class="label-details">CRECI</p>
                    <input class="input-details" v-model="selectedComissao.corretor.cpf" disabled>
                </div>
                <div class="uf-corretor">
                    <p class="label-details">UF CRECI</p>
                    <input disabled class="input-details" v-model="selectedComissao.corretor.creci">
                </div>
                <div class="basico-corretor">
                    <p class="label-details">Celular</p>
                    <input disabled class="input-details" v-model="selectedComissao.corretor.celular">
                </div>
                <div class="basico-corretor">
                    <p class="label-details">Telefone Comercial</p>
                    <input disabled class="input-details" v-model="selectedComissao.corretor.telefoneComercial">
                </div>
                <div class="basico-corretor">
                    <p class="label-details">Data de Nacimento</p>
                        <datepicker name="txtDateStart"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :disabled="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        v-model="selectedComissao.corretor.dataNascimento"/>
                </div>
                    <div class="basico-corretor">
                    <p class="label-details">RG</p>
                    <input disabled class="input-details" v-model="selectedComissao.corretor.rg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DetailsForm from './detailsforms'
export default DetailsForm
</script>

<style scoped>
.margin {
    margin-top: 1rem;
}
.left {
    margin-left: 1rem;
}

.nome-empreendimento{
    width: 40%;
}
.nome-cidade{
    width: 40%;
}
.nome-rua {
    width: 100%;
}
.torre-apartamento{
    width: 25%;
}
.cep-numero {
    width: 15%;
}

@media (min-width: 1901px) {
    .nome-corretor{
         width: 38%;
    }
    .basico-corretor{
       width: 17.2%;
    }
    .cpf-corretor{
        width: 22%;
    }
}
@media (min-width: 1441px) and (max-width: 1900px) {
    .nome-corretor{
         width: 38%;
    }
    .basico-corretor{
        width: 16.7%;
    }
    .cpf-corretor{
        width: 22%;
    }
}
@media (min-width: 1280px) and (max-width: 1440px){
    .nome-corretor{
        width: 38%;
    }
    .basico-corretor{
        width: 16.5%;
    }
    .cpf-corretor{
        width: 21.3%;
    }
}
@media (min-width: 1226px) and (max-width: 1279px){
    .nome-corretor{
        width: 38%;
    }
    .basico-corretor{
        width: 16.5%;
    }
    .cpf-corretor{
        width: 21.3%;
    }
}

@media (min-width: 1200px) and (max-width: 1225px){
    .nome-corretor{
        width: 38%;
    }
    .basico-corretor{
        width: 16.5%;
    }
    .cpf-corretor{
        width: 20.7%;
    }
}

@media (min-width: 1046px) and (max-width: 1199px) {
    .nome-corretor{
        width: 38%;
    }
    .basico-corretor{
        width: 16%;
    }
    .cpf-corretor{
        width: 20.4%;
    }
}

.uf-corretor{
    width: 10%;
}

#body-details{
    height: 100%;
    padding-bottom: 5%;
}

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
    margin-bottom: 15px;
}

.input-details{
    width: 100%;
    height: 35px;
    padding: 8px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}
.corpo-corretor{
    padding: 0 1rem 0 1rem;
    column-gap: 10px;
}

.label-details{
    margin-bottom: 0;
    font-size: 13px;
}

#card-details{
  height: 100%;
  background: white;
  margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/detailsforms/detailsforms.vue